import { render } from "./PoeBotSettings.vue?vue&type=template&id=547dee66"
import script from "./PoeBotSettings.vue?vue&type=script&lang=js"
export * from "./PoeBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__